
import { TechGrid, GlassCard } from '../../../components/base/FuturisticElements';

export function AboutHeroSection() {
  return (
    <section className="py-24 bg-gradient-to-b from-black to-gray-900">
      <TechGrid />
      
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-light mb-6 tracking-tight text-white">
            Democratizing Cybersecurity for UK SMEs
          </h1>
          <p className="text-xl mb-8 leading-relaxed font-light text-gray-400">
            We're a Manchester-based cybersecurity startup developing next-generation AI protection for the 5.5 million UK small and medium-sized enterprises facing escalating digital threats.
          </p>
          
          <div className="grid md:grid-cols-3 gap-8 mt-12">
            <GlassCard className="text-center">
              <div className="text-3xl font-light text-blue-400 mb-2">5.5M+</div>
              <div className="text-gray-400">Target UK SMEs</div>
            </GlassCard>
            <GlassCard className="text-center">
              <div className="text-3xl font-light text-blue-400 mb-2">Beta</div>
              <div className="text-gray-400">Development Stage</div>
            </GlassCard>
            <GlassCard className="text-center">
              <div className="text-3xl font-light text-blue-400 mb-2">2024</div>
              <div className="text-gray-400">Founded in Manchester</div>
            </GlassCard>
          </div>
        </div>
      </div>
    </section>
  );
}
